import React from 'react';
import OptimizedImage from './OptimizedImage';
import styles from './ArticlesSection.module.css';

const ArticlesSection = ({ articles }) => {

    if (!articles || articles.length === 0) return null;

    return (
        <section className={styles['desktop-articles-section']}>
            <h2 className={styles['desktop-section-heading']}>Articles</h2>
            <div className={styles['desktop-articles-grid']}>
                {articles.map(article => (
                    <a
                        key={article.id}
                        href={article.url}
                        target="_blank"
                        rel="noopener"
                        className={styles['desktop-article-card']}
                    >
                        <OptimizedImage
                            src={article.thumbnail}
                            fallbackSrc={"/player/fallback.png"}
                            alt=""
                            width={400}
                            height={250}
                            unoptimized
                        />
                        <span>{article.category}</span>
                        <h3 className={styles['article-title']}>{article.headline}</h3>
                        <time>{article.date}</time>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default ArticlesSection;
